import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query BlogCategoryQuery {
      allStoryblokEntry(
        filter: { lang: { eq: "default" }, field_component: { in: [ "Category" ] } }
        sort: { fields: published_at, order: ASC }
      ) {

        nodes {
          uuid
          name
          full_slug
        }
      }
    }
  `);

  return allStoryblokEntry.nodes;
};
